import React from "react";
import DynamicTabs from "../../components/Dynamic/DynamicTabs";
import { getStrukturaById } from "./data";
import Spinner from "../../containers/Spinner";
class StruktureIndex extends React.Component {
  state = { data: null };

  dostuff = async () => {
    let match = this.props.match;
    let data = await getStrukturaById(match.params.id);
    this.setState({ data });
  };
  componentWillMount() {
    this.dostuff();
  }
  componentWillReciveProps() {
    this.dostuff();
  }

  render() {
    if (!this.state.data) {
      return <Spinner />;
    }
    return (
      <div>
        <DynamicTabs data={this.state.data} />
      </div>
    );
  }
}

export default StruktureIndex;
